import React, { useEffect } from 'react';
import { useRefCallback } from 'src/utils/react/ref-callback.hook';

export function useConditionalBeforeUnloadListener(condition: boolean) {
  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      e.returnValue = 'Stop upload and discard?';
    };
    // attaching beforeunload event listener to window affects
    // the behavior of the browser's back/forward cache.
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event#usage_notes
    // https://developer.chrome.com/blog/page-lifecycle-api/#the-beforeunload-event
    // It's recommended to only attach the listener when you actually have to interrupt.
    if (condition) {
      window.addEventListener('beforeunload', handleBeforeUnload);
    } else {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    }
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [condition]);
}
